import React, { useState, useContext, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import Layout from './layout';
import PageBanner from '../modules/page-banner'
import { collectionNestedPaths, findParentHierarchy, parseShopifyMetafields } from '../utils/helpers';
import CollectionSubs from '../partials/collection/collection-subs';
import Breadcrumb from '../components/breadcrumb';
import banner from '../assets/images/cat.jpg'
import { ShopContext, ShopProvider } from '../context/shop-context-2';
import CollectionProducts from '../partials/collection/collection-products';
import Filters from '../partials/shop/filters';
import ViewedProducts from '../components/also-viewed-products';
import ArticlesForYou from '../components/articles-for-you';
import CustomSeo from '../components/customSeo';

const ShopTemplate = ({ collection, parentContext, location, seo, description }) => {
  const data = useStaticQuery(graphql`
    {
      products: allShopifyProduct(filter: {priceRangeV2: {maxVariantPrice: {amount: {gt: 0.01}}, minVariantPrice: {amount: {gt: 0.01}}}, status: {eq: ACTIVE}}) {
        nodes {
          title
          handle
          legacyResourceId
          storefrontId
          tracksInventory
          vendor
          productType
          tags
          collections {
            handle
          }
          filter_width: metafield(namespace: "filter", key: "filter_width") {
            value
          }
          filter_thickness: metafield(namespace: "filter", key: "filter_thinkness") {
            value
          }
          priceRangeV2 {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
          featuredImage {
            altText
            src
          }
          metafields {
            key
            namespace
            value
          }
          hasOnlyDefaultVariant
          variants {
            price
            compareAtPrice
            storefrontId
            availableForSale
            selectedOptions {
              name
            }
          }
        }
      }
      collections: allShopifyCollection {
        nodes {
          id
          title
          handle
          image {
            src
          }
          subCollections: metafield(namespace: "collection", key: "collection_subs") {
            value
          }
          collectionType: metafield(namespace: "arena", key: "collectionType") {
            value
          }
          subCollections: metafield(namespace: "collection", key: "collection_subs") {
            value
          }
          products {
            handle
            legacyResourceId
          }
        }
      }
    }
  `)

  let metafields = [];
  const subsHandles = collection.subs?.value ? collection.subs.value.split('|').filter(a => a) : [];
  const subs = collectionNestedPaths(data.collections.nodes).filter(col => {
    return subsHandles.includes(col.handle.split('/').pop())
  })

  metafields = collection ? parseShopifyMetafields(collection.metafields) : []
  const MaybeUpdateFilters = () => {
    const { setActiveFilters } = useContext(ShopContext);
    const [oldPath, setOldPath] = useState(location.pathname)

    useEffect(() => {
      if (location.pathname === oldPath) {
        const filtersToApply = [];
        const pathItems = location.pathname.split('/').filter(a => a);
        filtersToApply[pathItems[0]] = pathItems.filter((a, i) => i !== 0);

        setActiveFilters(filtersToApply)
      } else {
        setOldPath(location.pathname)
      }
    }, [oldPath, setActiveFilters])

    return null;
  }

  const parent = data.collections.nodes.find(col => {
    if(col.collection_subs) {
      return col.collection_subs.value.split('|').includes(collection.handle)
    }
    return false
  })?.handle;

  const pageProducts = collection?.products || [];

  return (
    <Layout>
      <CustomSeo
        title={seo?.title || `${collection?.title || 'Shop All'} - LENCO Supplies`}
        description={seo?.description || (collection?.title || 'Shop All')}
      />
      <ShopProvider
        pageProducts={pageProducts}
        allProducts={data.products.nodes}
        parentContext={parentContext}
        allCollections={data.collections.nodes}
        currentCollection={collection.handle}
        pageLocation={location}
      >
        {collection ? (
          <MaybeUpdateFilters />
        ) :
        (<h2>collection is not</h2>)}
        <PageBanner
          shop={true}
          title={collection.title || 'Shop All'}
          image={metafields?.collection_page && metafields.collection_page.collection_page_img ? metafields.collection_page.collection_page_img : banner}
        />
        <div className="Collection Container">
          {description && (
            <div className="Collection__description" dangerouslySetInnerHTML={{__html: description}} />
          )}
          {subs.length > 1 && location.pathname !== '/shop' && (
            <CollectionSubs subs={subs} current={collection.handle} parent={parent} />
          )}
          <Breadcrumb
            location={location}
            currentTitle={collection?.title || 'Shop All'}
            collectionHierarchy={findParentHierarchy(data.collections.nodes, collection.handle)}
          />
          <div className="Collection__inner">
            <Filters />
            <div className="Collection__products">
              <CollectionProducts
                location={location}
                shopTitle={'shop'}
              />
            </div>
          </div>

          <div className="Collection__previously">
            <ViewedProducts />
          </div>
          <div className="Collection__articles">
            <ArticlesForYou />
          </div>
        </div>
      </ShopProvider>
    </Layout>
  )
}

export default ShopTemplate
